<template>
  <div id="_2023_1">
    <div id="The-third-Asian-young-geographers-workshop" class="cos-modal">
      <h3><strong>The Third Asian Young Geographers Workshop Held Online</strong></h3>
      <small class="home-date">December 21, 2023<br></small>
      <hr>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The Third Asian Young Geographers Workshop was held online on
        December 16–17, 2023. The workshop was jointly organized by the Young Geographers Working
        Group of the Asian Geographical Association (AGA-YGWG), the Working Committee for Young
        Geographers of the Geographical Society of China (GSC-WCYG), and the Young Scientist
        Innovation Network of the International Society for Digital Earth (ISDE-YSIN), with
        support from the International Geographical Union. Under the theme “Geography in a New
        Era,” the workshop invited eight renowned experts and scholars from China and abroad to
        deliver keynote presentations. Drawing on their latest research, participants shared
        their understanding of and reflections on the future direction of geography in the new
        era and proposed innovative solutions to issues such as global change and sustainable
        development. The workshop featured discussions on 20 related topics, with 286 scholars
        giving oral presentations. In total, 637 online attendances were recorded from 25
        countries and regions around the world.
      </p>

      <div class="pic">
        <img
          src="../../../assets/static/img/Events/2023_1/workshop-overview.png"
          alt="Participants in the Third Asian Young Geographers Workshop"
        >
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The workshop officially opened at 11:00 a.m. Beijing Time on
        December 16. The opening ceremony was chaired by Prof. Min Chen of Nanjing Normal
        University, Chair of AGA-YGWG. Prof. Lai Vinh Cam of the Institute of Geography, Vietnam
        Academy of Science and Technology, Vice President of the Asian Geographical Association;
        Prof. Barbaros Gönençgil of Istanbul University, Türkiye, Secretary General of the
        International Geographical Union; and Dr. Zhen Liu of the Secretariat of the International
        Society for Digital Earth attended the ceremony and delivered welcome addresses on behalf
        of their respective organizations.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The keynote presentations began after the opening ceremony. The
        first keynote session was chaired by Associate Prof. Li He of Xi’an Jiaotong University,
        Secretary General of AGA-YGWG. Prof. Pengjun Zhao of Peking University, a Fellow of the
        Academy of Social Sciences in the United Kingdom; Prof. Sunil Kumar De of North-Eastern
        Hill University, India, President of the International Association of Geomorphologists;
        Prof. Xiaoping Yang of Zhejiang University; and Prof. Atta Ur Rahman of the University of
        Peshawar, President of the Pakistan Geographical Association, delivered keynote
        presentations entitled “Decarbonization Pathways for Freight Transport in China,”
        “Contemporary Geomorphology and Danxia Landforms,” “Deserts and Earth System Science:
        Taking China’s Deserts as an Example,” and “Transboundary Hydrology, Climate Change, and
        Their Impacts on Recurrent Flooding in the Kabul River Basin,” respectively.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The second keynote session was held on the morning of December 17
        and chaired by Associate Prof. Suh-hee Choi of Kyung Hee University, Republic of Korea,
        AGA-YGWG’s Regional Contact for East Asia. Prof. Wenwen Li of Arizona State University,
        United States; Prof. Philippe De Maeyer of Ghent University, Belgium, former Vice
        President of the International Cartographic Association; Researcher Erfu Dai of the
        Institute of Geographic Sciences and Natural Resources Research, Chinese Academy of
        Sciences, Chair of GSC-WCYG; and Associate Prof. Junxi Qian of The University of Hong Kong
        delivered presentations entitled “GeoAI Vision Foundation Models for Environmental
        Analysis,” “The Evolving Relationship between Geography and Cartography,” “Ecosystem
        Services on the Qinghai–Tibet Plateau: Assessment, Trade-offs, and Decision-Making,” and
        “Vernacular Modernization and Community Economies in Southwest China,” respectively.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Over the two-day workshop, participating young geographers also
        presented their research and exchanged ideas in parallel sessions covering security
        geography and governance; coordination between regional transport networks and land
        ecological security; urbanization and ecological sustainability; conservation of Asian
        blue-carbon ecosystems under climate change; geospatial science for land management;
        multidisciplinary research and practices for green urbanization; relationships between
        land use and disaster risk; population change and regional sustainability; ecohydrology
        under global environmental change; geospatial assessments of biomass fuel availability;
        spatial accessibility and spatial justice; urban scenario simulation and analysis using
        large-scale spatiotemporal data; the development of urban and rural socio-spatial
        structures; tourism geography in the new era; surface processes in arid regions and their
        environmental impacts; opportunities and challenges during the sustainable energy
        transition; and monitoring ecosystem structure and function. With the cooperation and
        support of the Vietnam Geographical Society and the International Association of
        Geomorphologists Working Group on Red Beds and Danxia Geomorphology, special events were
        also held on December 17, including the China–Vietnam Young Geographers Bilateral Forum
        and the Forum on Frontiers in Danxia Geomorphology Research.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The closing ceremony was held on the evening of December 17 and
        chaired by Associate Prof. Li He. Prof. Min Chen delivered the concluding remarks,
        reporting the workshop’s initial outcomes, introducing the organizational structure and
        recent activities of AGA-YGWG, and thanking the other organizing committee members,
        volunteers, and all participants. He also announced that the next workshop was expected
        to be held in person. Researcher Erfu Dai, Chair of GSC-WCYG, then announced the winners
        of the Best Paper Awards. Following a comprehensive assessment by the workshop’s review
        committee, nine papers were selected. Three award representatives—Issac Sarfo of Henan
        University, Sakib Rahman Siddique Shuvo of Bangladesh University of Engineering and
        Technology, and Rui Zhu of the Institute of High Performance Computing, A*STAR,
        Singapore—gave acceptance speeches.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The Asian Young Geographers Workshop pioneered a new forum for
        exchange among young geographers in Asia. Its inaugural meeting in December 2021 created
        a new international platform, promoted exchange and cooperation among geographical
        institutions and young geographers across Asia, and advanced the development of the Asian
        Geographical Association. Held online for three consecutive years, the workshop has
        further strengthened its identity and expanded the platform’s influence.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Established in 2020, the Young Geographers Working Group of the
        Asian Geographical Association (AGA-YGWG) aims to provide young geographers with a
        platform for collaboration and academic exchange. Focusing on major issues such as the
        environment, health, and sustainable development, it brings together young geographers
        from physical geography, human geography, geographic information science, and related
        fields to build a closely connected Asian academic community.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2023_1'
}
</script>

<style lang="less" scoped>
#_2023_1 {
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 2.2rem auto 0;
  position: relative;
  word-spacing: 0.3rem;
  min-height: 2500px;
  text-align: justify;
}

h3 {
  color: #117450;
  font-size: 1.3rem;
  font-weight: 1000;
}

.home-date {
  font-weight: bold;
  color: grey;
}

.pic {
  width: 100%;
  margin: 2% 0;
  text-align: center;
}

.pic img {
  display: inline-block;
  max-width: 80%;
  height: auto;
}

@media (max-width: 768px) {
  #_2023_1 {
    width: 88%;
    min-height: 0;
  }

  .pic img {
    max-width: 100%;
  }
}
</style>
